import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/shared/Navbar.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Toaster.jsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/Providers.jsx")